module.exports = __webpack_public_path__ + "media/images/player/extensions/tmobile_logo-90acd05e37b2a0509f38f21194213da8.png";